import { useSelector, useDispatch } from 'react-redux';

import { getCartTitle } from 'common/helpers/miscHelpers';
import { currencyFormat } from 'common/helpers/numberHelper';
import Image from 'products/common/components/Image';
import { addCartItem } from 'redux/cart/actions';
import { useLocalization } from 'redux/localization/utils/hooks';

const ProductUpsell = (props) => {
  const { carrot } = props;
  const dispatch = useDispatch();
  const { t } = useLocalization();
  const settings = useSelector((state) => state.setting.data);
  const { currency } = settings;

  const { product } = carrot;

  if (carrot.type === 'Product Upsell' && !product) {
    return null;
  }

  const variant = product.variants?.[0];

  const handleAddToCart = () => {
    const item = {
      quantity: 1,
      sku: variant.sku
    };

    dispatch(addCartItem(item));
  };

  return (
    <div className="c7-carrot c7-carrot--product-upsell">
      {carrot.content?.length > 0 && (
        <div
          className="c7-carrot__message"
          dangerouslySetInnerHTML={{ __html: carrot.content }}
        />
      )}
      <div className="c7-carrot__product">
        <div className="c7-carrot__product__image">
          <Image
            product={product}
            imageDisplay="One"
            size="small"
            linkType="None"
            index={0}
          />
        </div>
        <div className="c7-carrot__product__details">
          <div className="c7-carrot__product__details__title">
            {product.title}
          </div>
          <div className="c7-carrot__product__details__variant c7-alt-text">
            {variant.title}
          </div>
          <div className="c7-carrot__product__details__price">
            <span className="c7-sr-only">
              {t('general.accessibility.itemPrice')}
            </span>
            <Price variant={variant} currency={currency} />
          </div>
          <button
            className="c7-btn c7-btn--primary--small"
            type="button"
            onClick={handleAddToCart}
          >
            {t('products.general.addToCart', {
              cartTitle: getCartTitle(settings, t)
            })}
            <span className="c7-sr-only">, {product.title}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

const Price = (props) => {
  const { variant, currency } = props;
  const { t } = useLocalization();

  // Get dynamic pricing if available
  const effectivePrice = variant.addToCartPrice ?? variant.price;
  const comparePrice = variant.comparePrice || variant.price;

  // Show discounted price if there's a difference
  if (comparePrice > effectivePrice) {
    return (
      <>
        <span className="c7-price--original">
          <span className="c7-sr-only">{t('general.accessibility.was')} </span>
          {currencyFormat(comparePrice, currency)}
        </span>
        <span className="c7-price--discounted">
          <span className="c7-sr-only">{t('general.accessibility.now')} </span>
          {currencyFormat(effectivePrice, currency)}
        </span>
      </>
    );
  }

  return currencyFormat(effectivePrice, currency);
};

export default ProductUpsell;
